import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getPageError, useAppContext } from "../contextProviders/AppContext";

const PageError = () => {
  const { useSelector } = useAppContext();
  const pageError = useSelector(getPageError);
  const history = useHistory();

  useEffect(() => {
    if (pageError) {
      history.push("/error");
    }
  }, [pageError, history]);

  return null;
};

export default PageError;
